import { styled } from 'styled-components';
import { BORDER_RADIUS } from './constants.js';
export const Wrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey01_1};
  border: 1px solid ${({ theme, error }) => (error ? theme.colors.critical30 : theme.colors.grey10_1)};
  border-radius: ${BORDER_RADIUS}px;
  margin-bottom: ${({ bottomSpacer }) => (bottomSpacer ? '16px' : '0')};
  width: 100%;
  overflow: hidden;
`;
export const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px 12px;
  cursor: pointer;
  min-height: 50px;
`;
export const Section = styled.div `
  padding: 4px 24px 24px;
`;
export const Title = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  ${({ theme }) => theme.typography.textLarge};
  margin: 0;
  max-width: calc(100% - 36px);
  span {
    word-break: break-all;
  }
`;
export const Footer = styled.div `
  padding: 18px 24px 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
  background: ${({ theme }) => theme.colors.grey05_1};
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;
